/* Foliant — native Shopify Ajax cart, drawer, quantity, gallery, variants. */
(function () {
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  /* ---------- Drawer ---------- */
  function drawer() { return $('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---------- Rendering ---------- */
  function refreshSections() {
    var ids = ['cart-drawer'];
    if (document.body.classList.contains('template-cart')) ids.push('main-cart');
    return fetch(routes + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        Object.keys(data).forEach(function (id) {
          var html = new DOMParser().parseFromString(data[id], 'text/html');
          var incoming = html.querySelector('[data-section-id="' + id + '"]');
          var target = $('[data-section-id="' + id + '"]');
          if (incoming && target) {
            target.innerHTML = incoming.innerHTML;
            if (window.FoliantReveal) window.FoliantReveal.showAll(target);
          }
        });
        return fetch(routes + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
  }

  function setBusy(button, busy, label) {
    if (!button) return;
    button.disabled = busy;
    if (busy) {
      button.dataset.label = button.textContent;
      button.textContent = label || 'Adding…';
    } else if (button.dataset.label) {
      button.textContent = button.dataset.label;
    }
  }

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[data-add-to-cart]');
    var errorEl = form.querySelector('[data-cart-error]');
    if (errorEl) errorEl.textContent = '';
    setBusy(button, true);

    fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(form.querySelector('[name="id"]').value),
            quantity: Number((form.querySelector('[name="quantity"]') || { value: 1 }).value || 1)
          }
        ]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return refreshSections().then(openDrawer);
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = err.message || 'Could not add to cart.';
      })
      .finally(function () { setBusy(button, false); });
  });

  /* ---------- Line item changes ---------- */
  function changeLine(line, quantity) {
    return fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(refreshSections);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var toggle = target.closest('[data-cart-open]');
    if (toggle) { event.preventDefault(); refreshSections().then(openDrawer); return; }

    if (target.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }

    var remove = target.closest('[data-line-remove]');
    if (remove) { event.preventDefault(); changeLine(remove.dataset.lineRemove, 0); return; }

    var step = target.closest('[data-qty-step]');
    if (step) {
      event.preventDefault();
      var wrap = step.closest('[data-qty]');
      var input = wrap.querySelector('input');
      var min = Number(input.min || 1);
      var max = input.max ? Number(input.max) : Infinity;
      var next = Number(input.value || min) + Number(step.dataset.qtyStep);
      input.value = Math.min(max, Math.max(min, next));
      if (input.dataset.line) changeLine(input.dataset.line, input.value);
      return;
    }

    var thumb = target.closest('[data-gallery-thumb]');
    if (thumb) {
      event.preventDefault();
      var main = $('[data-gallery-main] img');
      if (main) {
        main.src = thumb.dataset.full;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = thumb.dataset.alt || main.alt;
      }
      $$('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    var burger = target.closest('[data-menu-toggle]');
    if (burger) {
      var header = burger.closest('[data-header]');
      header.classList.toggle('is-menu-open');
      burger.setAttribute('aria-expanded', header.classList.contains('is-menu-open'));
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty] input[data-line]');
    if (input) changeLine(input.dataset.line, input.value);

    var variantSelect = event.target.closest('[data-variant-select]');
    if (variantSelect) {
      var form = variantSelect.closest('form[data-product-form]');
      var picker = variantSelect.closest('[data-variants]');
      var chosen = $$('[data-variant-select]', picker).map(function (s) { return s.value; }).join(' / ');
      var variants = JSON.parse(picker.querySelector('[data-variants-json]').textContent);
      var match = variants.filter(function (v) { return v.title === chosen; })[0];
      var idInput = form.querySelector('[name="id"]');
      var button = form.querySelector('[data-add-to-cart]');
      var priceEl = $('[data-product-price]');
      if (match) {
        idInput.value = match.id;
        if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
        button.disabled = !match.available;
        button.textContent = match.available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  window.FoliantCart = { open: openDrawer, close: closeDrawer, refresh: refreshSections };
})();
